import {useIssueState} from '@github-ui/issue-pr-state'
import type {IssuePickerItem} from '@github-ui/item-picker/IssuePicker'
import {ActionList} from '@primer/react'
import {useCallback} from 'react'

export type IssueItemData = {
  id: string
  number: number
  title: string
  url: string
  state: IssuePickerItem['state']
  stateReason?: IssuePickerItem['stateReason']
  repository: {
    nameWithOwner: string
  }
}

type IssueItemProps = {
  issue: IssueItemData
  onLinkClick?: (url: string) => void
}

export function IssueItem({issue, onLinkClick}: IssueItemProps) {
  const handleClick = useCallback(() => {
    onLinkClick?.(issue.url)
  }, [issue.url, onLinkClick])

  const {sourceIcon} = useIssueState({
    state: issue.state,
    stateReason: issue.stateReason,
  })

  const IconComponent = sourceIcon('Issue')

  return (
    <ActionList.LinkItem href={issue.url} target="_blank" onClick={handleClick}>
      <ActionList.LeadingVisual>
        {/* eslint-disable-next-line react-hooks/static-components */}
        <IconComponent />
      </ActionList.LeadingVisual>
      <span className="markdown-title">{issue.title}</span>
      <ActionList.Description variant="block">
        {issue.repository.nameWithOwner}#{issue.number}
      </ActionList.Description>
    </ActionList.LinkItem>
  )
}

try{ IssueItem.displayName ||= 'IssueItem' } catch {}
try{ IconComponent.displayName ||= 'IconComponent' } catch {}